import { render } from "./newProject.vue?vue&type=template&id=74a81ea2"
import script from "./newProject.vue?vue&type=script&lang=js"
export * from "./newProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__